import { refundImageAiInfoApi, returnImageAiInfoApi } from '@service';
import { Button, message } from 'antd';
import clsx from 'clsx';
import React, { useState } from 'react';

const apiMap = {
  refund: refundImageAiInfoApi,
  return: returnImageAiInfoApi,
}

export function AiDetectButton({ className, type, url, data = null }) {
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(data)

  async function handleDetect() {
    setLoading(true)

    try {
      const apiRequest = apiMap[type];

      if (!apiRequest) {
        throw new Error('暂不支持该识别类型');
      }

      const res = await apiRequest(url);

      if (res.flag !== 200) {
        throw new Error(res.msg);
      }

      setResult(res.data);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false)
    }
  }

  if (result) {
    return (
      <div className={clsx(result.is_ai ? 'conspicuous-red' : 'conspicuous-green', className)}>
        识别结果：{result.is_ai ? `是 AI 图的概率为 ${result.confidence}%` : '不是 AI 图'} ({result.reason})
      </div>
    );
  }

  return (
    <Button className={className} loading={loading} onClick={handleDetect}>
      AI图片识别
    </Button>
  );
}
